// extracted by mini-css-extract-plugin
export default {"notFound":"NotFoundPage_notFound__343HW","actions":"NotFoundPage_actions__-t4tS"};